let fileTable = [
  {
    label: "文件名称",
    prop: "name",
    sortable: 1,
  },
  {
    label: "文件路径",
    prop: "url",
    sortable: 1,
  },

]

export {
  fileTable,
}